/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Typography } from '@material-ui/core';
import { format as formatDate } from 'date-fns';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import LwtTable, { ColumnProps } from 'components/@common/Table/LwtTable';
import { KeyStudentEngagementAssessmentResult } from 'types/schema-generated-types';

const DATE_FORMAT = 'MM/dd/yyyy';

const getColumns: (t: TFunction) => ColumnProps<any>[] = (t: TFunction) => [
  {
    id: 'dateCompleted',
    label: t('Date'),
    sortKey: 'dateCompleted',
    getValue: item => (
      <Typography>{formatDate(new Date(item.dateCompleted), DATE_FORMAT)}</Typography>
    ),
    sortable: true
  },
  {
    id: 'aborted',
    label: t('Status'),
    helpText: t('assessmentStatus', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'aborted',
    getValue: item => <Typography>{item.aborted ? t('Skipped') : t('Completed')}</Typography>,
    sortable: true
  },
  {
    id: 'averageWpm',
    label: t('Speed (WPM)'),
    helpText: t('wpm', { ns: 'ReportsHelpCommon' }),
    sortKey: 'averageWpm',
    getValue: item => <Typography>{item.averageWpm}</Typography>,
    sortable: true
  },
  {
    id: 'averageAccuracy',
    label: t('Accuracy'),
    helpText: t('accuracy', { ns: 'ReportsHelpCommon' }),
    sortKey: 'averageAccuracy',
    getValue: item => <Typography>{item.averageAccuracy}%</Typography>,
    sortable: true
  }
];

const AssessmentTable: React.FC<{
  reportData?: KeyStudentEngagementAssessmentResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);
  const columns = getColumns(t);

  return (
    <ReportCard title={t('Teacher Assigned Assessments')} loading={loading} reportData={reportData}>
      <LwtTable columns={columns} data={reportData} />
    </ReportCard>
  );
};

export default AssessmentTable;
